<template>
    <div>
        <el-form label-position="left" label-width="60px">
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="商品名">
                        <el-input v-model="filter.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="价格">
                        <el-input v-model="filter.price"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="20">
                    <el-form-item label="数量">
                        <el-input v-model="filter.amount" type="number"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div class="m-portlet__foot">
            <div style="text-align: right">
                <el-button @click="handleStoreGood" :loading="$parentInfo.store_goods.button_loading">创建</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateGoods",
        data() {
            return {
                filter:{
                    name:'',
                    price:'',
                    amount:'',
                }
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleStoreGood(){
                this.$parentInfo.store_goods.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'store_goods', {'filter':this.filter});
            }
        }
    }
</script>

<style scoped>

</style>